import { render } from "./MSidebarFeature.vue?vue&type=template&id=2e8ed524&scoped=true"
import script from "./MSidebarFeature.vue?vue&type=script&lang=js"
export * from "./MSidebarFeature.vue?vue&type=script&lang=js"

import "./MSidebarFeature.vue?vue&type=style&index=0&id=2e8ed524&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8ed524"]])

export default __exports__